import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {NgbAlert} from "@ng-bootstrap/ng-bootstrap";
import {NgForOf} from "@angular/common";
import {ActivatedRoute, Router, RouterLink} from "@angular/router";
import {AuthService, SignUpResult} from "../auth.service";
import {Subscription} from "rxjs";
import {PasswordFieldState} from "../../common/password-field-state";
import {AlertService} from "../../common/alert/alert.service";
import {AlertComponent} from "../../common/alert/alert.component";

@Component({
    selector: 'app-signup',
    templateUrl: './sign-up.component.html',
    imports: [
        ReactiveFormsModule,
        RouterLink,
        AlertComponent
    ],
    styleUrls: ['./sign-up.component.css'],
    providers: [AlertService]
})
export class SignUpComponent implements OnInit, OnDestroy {
    private subscriptions: Subscription[] = [];
    private formBuilder = new FormBuilder().nonNullable

    private name = this.formBuilder.control("");
    private email = this.formBuilder.control(
        "",
        {validators: [Validators.email]}
    );
    private password = this.formBuilder.control(
        '',
        {validators: Validators.minLength(6)}
    )

    signUpForm = new FormGroup({
        name: this.name,
        email: this.email,
        password: this.password
    });

    passwordState = new PasswordFieldState()
    isLoading: boolean = false;

    constructor(private authService: AuthService, private router: Router, private route: ActivatedRoute, private alertService: AlertService) {

    }

    ngOnInit() {
        this.subscriptions.push(
            this.authService.user.subscribe(user => {
                if (user) {
                    this.router.navigateByUrl(this.route.snapshot.queryParamMap.get('redirectUrl') ?? "rounds")
                }
            })
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe())
    }

    signUp() {
        this.clearState();
        this.isLoading = true;
        this.subscriptions.push(
            this.authService.signUpWithEmail(this.name.value, this.email.value, this.password.value)
                .subscribe(result => {
                    this.clearState();
                    if (result != SignUpResult.Success) {
                        this.alertService.showAlert('danger', 'Sign up failed');
                    }
                })
        );
    }

    private clearState() {
        this.alertService.clearAlerts();
        this.isLoading = false;
    }
}

